import { render, staticRenderFns } from "./SnacksHome.vue?vue&type=template&id=6789cd3e&scoped=true"
import script from "./SnacksHome.vue?vue&type=script&lang=js"
export * from "./SnacksHome.vue?vue&type=script&lang=js"
import style0 from "./SnacksHome.vue?vue&type=style&index=0&id=6789cd3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6789cd3e",
  null
  
)

export default component.exports